import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import Logo from '../components/Logo'
import TimeFavoritoSelector from '../components/TimeFavoritoSelector'

function forcaSenha(senha) {
  const len = senha.length >= 8
  const upper = /[A-Z]/.test(senha)
  const num = /[0-9]/.test(senha)
  return { len, upper, num, score: (len ? 1 : 0) + (upper ? 1 : 0) + (num ? 1 : 0) }
}

function normalizarWhatsapp(valor) {
  const limpo = valor.trim()
  // Internacional explícito: começa com +
  if (limpo.startsWith('+')) {
    const digits = limpo.replace(/\D/g, '')
    if (digits.length < 7 || digits.length > 15) return null
    return '+' + digits
  }
  const digits = limpo.replace(/\D/g, '')
  let numero = digits
  // Remove DDI 55 se digitado junto (ex: 5511999998888)
  if (numero.startsWith('55') && numero.length > 11) numero = numero.slice(2)
  // Número brasileiro: 10 ou 11 dígitos
  if (numero.length === 10 || numero.length === 11) {
    const ddd = numero.slice(0, 2)
    const rest = numero.slice(2)
    return rest.length === 9
      ? `+55 (${ddd}) ${rest.slice(0, 5)}-${rest.slice(5)}`
      : `+55 (${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}`
  }
  // Internacional sem +: aceita se tiver entre 8 e 15 dígitos
  if (digits.length >= 8 && digits.length <= 15) return '+' + digits
  return null
}

export default function Cadastro() {
  const { signUp } = useAuth()
  const navigate = useNavigate()
  const [form, setForm] = useState({ primeiroNome: '', ultimoNome: '', email: '', whatsapp: '', senha: '', confirmar: '' })
  const [timeFavorito, setTimeFavorito] = useState(null)
  const [mostrarSenha, setMostrarSenha] = useState(false)
  const [mostrarConfirmar, setMostrarConfirmar] = useState(false)
  const [erro, setErro] = useState('')
  const [sucesso, setSucesso] = useState(false)
  const [loading, setLoading] = useState(false)
  const forca = forcaSenha(form.senha)
  const forcaCores = ['#eee', '#FCEBEB', '#FAEEDA', '#EAF3DE']

  function handleChange(e) { setForm({ ...form, [e.target.name]: e.target.value }) }

  async function handleSubmit(e) {
    e.preventDefault()
    setErro('')
    if (!form.primeiroNome.trim()) return setErro('Informe seu primeiro nome.')
    if (!form.ultimoNome.trim()) return setErro('Informe seu último nome.')
    if (!form.whatsapp.trim()) return setErro('Informe seu WhatsApp.')
    const whatsappNorm = normalizarWhatsapp(form.whatsapp)
    if (!whatsappNorm) return setErro('WhatsApp inválido. Brasil: use DDD + número (ex: 11999998888). Internacional: inclua o + e o código do país (ex: +351987654321).')
    if (forca.score < 3) return setErro('A senha não atende todos os requisitos.')
    if (form.senha !== form.confirmar) return setErro('As senhas não coincidem.')
    setLoading(true)
    const { error } = await signUp({ primeiroNome: form.primeiroNome, ultimoNome: form.ultimoNome, email: form.email, senha: form.senha, whatsapp: whatsappNorm, timeFavorito })
    setLoading(false)
    if (error) {
      setErro(error.message === 'User already registered' ? 'Este e-mail já está cadastrado.' : 'Erro ao criar conta. Tente novamente.')
    } else {
      setSucesso(true)
    }
  }

  // Tela de sucesso — aguardando confirmação de email
  if (sucesso) {
    return (
      <div style={s.wrap}>
        <div style={s.card}>
          <div style={s.logo}><Logo size={180} /></div>
          <div style={s.sucessoIcon}>📬</div>
          <h1 style={s.title}>Confirme seu e-mail</h1>
          <p style={s.sub}>Enviamos um e-mail de confirmação para:</p>
          <p style={{ ...s.sub, fontWeight: 500, color: '#0A2342', marginBottom: '1.2rem' }}>{form.email}</p>
          <div style={s.sucessoBox}>
            <p style={s.sucessoTexto}>
              <strong>Antes de fazer login, você precisa confirmar seu e-mail.</strong>
            </p>
            <p style={s.sucessoTexto}>
              Abra o e-mail com assunto <em>"Confirm your signup"</em> e clique no link de confirmação.
            </p>
            <p style={s.sucessoTexto}>
              Após confirmar, volte aqui e faça login. Sua conta será analisada pelo administrador antes de você poder participar.
            </p>
          </div>
          <p style={s.sucessoDica}>Não recebeu? Verifique a pasta de spam ou lixo eletrônico.</p>
          <Link to="/login" style={s.btnLink}>Ir para o login</Link>
        </div>
      </div>
    )
  }

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.logo}><Logo size={240} /></div>
        <h1 style={s.title}>Criar sua conta</h1>
        <p style={s.sub}>Preencha os dados para participar</p>
        <form onSubmit={handleSubmit} autoComplete="off">
          <div style={s.row}>
            <div style={{ ...s.field, flex: 1 }}>
              <label style={s.label}>Primeiro nome</label>
              <input style={s.input} name="primeiroNome" value={form.primeiroNome} onChange={handleChange} placeholder="Ex: Paulo" autoComplete="off" required />
            </div>
            <div style={{ ...s.field, flex: 1 }}>
              <label style={s.label}>Último nome</label>
              <input style={s.input} name="ultimoNome" value={form.ultimoNome} onChange={handleChange} placeholder="Ex: Mastrocinque" autoComplete="off" required />
            </div>
          </div>
          <div style={s.field}>
            <label style={s.label}>E-mail</label>
            <input style={s.input} type="email" name="email" value={form.email} onChange={handleChange} placeholder="seu@email.com" autoComplete="off" required />
          </div>
          <div style={s.field}>
            <label style={s.label}>WhatsApp <span style={{ color: '#D85A30' }}>*</span></label>
            <input style={s.input} type="tel" name="whatsapp" value={form.whatsapp} onChange={handleChange} placeholder="Ex: (11) 99999-9999 ou +351 987 654 321" required />
            <span style={s.hint}>Brasil: DDD + número (ex: 11999998888) · Internacional: com + e código do país (ex: +351987654321)</span>
          </div>
          <div style={s.field}>
            <label style={s.label}>Time favorito <span style={{ fontSize: 10, color: '#aaa', fontWeight: 400 }}>(opcional)</span></label>
            <TimeFavoritoSelector valor={timeFavorito} onChange={setTimeFavorito} />
          </div>
          <div style={s.field}>
            <label style={s.label}>Senha</label>
            <div style={{ position: 'relative' }}>
              <input style={{ ...s.input, paddingRight: 40 }} type={mostrarSenha ? 'text' : 'password'}
                name="senha" value={form.senha} onChange={handleChange} placeholder="Mínimo 8 caracteres"
                autoComplete="new-password" required />
              <button type="button" onClick={() => setMostrarSenha(!mostrarSenha)} style={s.eyeBtn} aria-label="Mostrar senha">
                {mostrarSenha ? '🙈' : '👁'}
              </button>
            </div>
            <div style={{ height: 3, borderRadius: 2, marginTop: 5, background: forcaCores[forca.score], transition: 'background .2s' }}></div>
            <div style={s.reqs}>
              <span style={{ color: forca.len ? '#3B6D11' : '#999' }}>{forca.len ? '✓' : '✗'} Mínimo 8 caracteres</span>
              <span style={{ color: forca.upper ? '#3B6D11' : '#999' }}>{forca.upper ? '✓' : '✗'} Uma letra maiúscula</span>
              <span style={{ color: forca.num ? '#3B6D11' : '#999' }}>{forca.num ? '✓' : '✗'} Um número</span>
            </div>
          </div>
          <div style={s.field}>
            <label style={s.label}>Confirmar senha</label>
            <div style={{ position: 'relative' }}>
              <input style={{ ...s.input, paddingRight: 40 }} type={mostrarConfirmar ? 'text' : 'password'}
                name="confirmar" value={form.confirmar} onChange={handleChange} placeholder="Repita a senha"
                autoComplete="new-password" required />
              <button type="button" onClick={() => setMostrarConfirmar(!mostrarConfirmar)} style={s.eyeBtn} aria-label="Mostrar confirmação de senha">
                {mostrarConfirmar ? '🙈' : '👁'}
              </button>
            </div>
          </div>
          {erro && <p style={s.erro}>{erro}</p>}
          <button style={s.btn} type="submit" disabled={loading}>{loading ? 'Criando conta...' : 'Criar conta'}</button>
        </form>
        <div style={s.seguranca}>
          <div style={s.segTitulo}>🔒 Seus dados estão protegidos</div>
          <div style={s.segItem}><strong>Senha criptografada:</strong> transformada em hash bcrypt. Ninguém consegue visualizá-la, nem o administrador.</div>
          <div style={s.segItem}><strong>Dados isolados:</strong> políticas de segurança em nível de banco (RLS) garantem que cada participante acessa apenas seus próprios dados.</div>
          <div style={s.segItem}><strong>Infraestrutura:</strong> dados armazenados com criptografia em repouso e em trânsito (TLS) pelo Supabase.</div>
          <div style={s.segItem}><strong>WhatsApp:</strong> usado apenas para lembretes do campeonato. Nunca compartilhado com terceiros.</div>
        </div>
        <p style={s.link}>Já tem conta? <Link to="/login">Entrar</Link></p>
      </div>
    </div>
  )
}

const s = {
  wrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', background: '#f5f5f5' },
  card: { background: 'white', borderRadius: 12, padding: '2rem', width: '100%', maxWidth: 440, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' },
  logo: { display: 'flex', justifyContent: 'center', marginBottom: '1.2rem' },
  title: { fontSize: 16, fontWeight: 500, textAlign: 'center', marginBottom: 4 },
  sub: { fontSize: 13, color: '#666', textAlign: 'center', marginBottom: 4 },
  row: { display: 'flex', gap: 10 },
  field: { marginBottom: '1rem' },
  label: { display: 'block', fontSize: 12, color: '#666', marginBottom: 4 },
  input: { width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  eyeBtn: { position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16 },
  hint: { fontSize: 11, color: '#999', marginTop: 3, display: 'block' },
  reqs: { display: 'flex', flexDirection: 'column', gap: 2, fontSize: 11, marginTop: 4 },
  btn: { width: '100%', padding: 12, background: '#D85A30', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer', marginTop: 4 },
  btnLink: { display: 'block', width: '100%', padding: 12, background: '#0A2342', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer', marginTop: 12, textAlign: 'center', textDecoration: 'none', boxSizing: 'border-box' },
  erro: { color: '#A32D2D', fontSize: 13, background: '#FCEBEB', padding: '8px 12px', borderRadius: 8, marginBottom: 8 },
  link: { fontSize: 12, color: '#666', textAlign: 'center', marginTop: 10 },
  seguranca: { marginTop: '1.2rem', background: '#f0f4f8', borderRadius: 8, padding: '12px 14px', border: '0.5px solid #d0dce8' },
  segTitulo: { fontSize: 12, fontWeight: 500, color: '#0A2342', marginBottom: 8 },
  segItem: { fontSize: 11, color: '#555', marginBottom: 6, lineHeight: 1.5 },
  sucessoIcon: { fontSize: 48, textAlign: 'center', marginBottom: 8 },
  sucessoBox: { background: '#EAF3F8', border: '0.5px solid #378ADD', borderRadius: 8, padding: '12px 14px', marginBottom: 12 },
  sucessoTexto: { fontSize: 13, color: '#1A5C9A', marginBottom: 6, lineHeight: 1.5 },
  sucessoDica: { fontSize: 12, color: '#999', textAlign: 'center', marginBottom: 4 },
}
